import { render, staticRenderFns } from "./BankAccountsModalWithOtp.vue?vue&type=template&id=2b415168&"
import script from "./BankAccountsModalWithOtp.vue?vue&type=script&lang=js&"
export * from "./BankAccountsModalWithOtp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports